import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PartsCategoryLayer from "../components/PartsCategoryLayer";

const PartsCategoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Parts Categories' />

        {/* PartsCategoryLayer */}
        <PartsCategoryLayer />
      </MasterLayout>
    </>
  );
};

export default PartsCategoryPage;
